
import { defineComponent } from 'vue'
import user from '../utils/user'
import { CompanyItemDto, getCompanyListApi, replaceCompany } from '@/api/alipay-recharge'
import global from '@/utils/global'

export default defineComponent({
  name: 'Login',
  data() {
    return {
      companyList: [] as CompanyItemDto[],
      showcompany: false, //此处默认要false
      userName: '',
      password: '',
      verityCode: '',
      smsCode: '',
      isStorage: false,
      verityImg: '',
      uuid: '',
      isQr: false,
      countdown: 0,
      isSending: false,
      timer: null as any
    }
  },

  watch: {
    async $route(to, from) {
      console.log(to.query, 'jdsgujisiuj')
      if (to.query.isNext && to.query.code) {
        this.showcompany = true
        let loginData = await user.codeLogin(to.query.code)
        this.companyList = loginData.companyList as CompanyItemDto[]
        global.token = loginData.token
        sessionStorage.token = loginData.token
      }
    }
  },
  async created() {
    // start 2024.10.17 微信登录授权跳转的redirect_uri路径变掉了，类似于https://yy.51zidan.com/?code=091x4Zll2J7Gne4cO7ol2nsYnK2x4Zlu&state=saas#/login，导致路由里变化里监听不到变化无法调用接口，所以加了这个判断操作
    const href = window.location.href
    if (href.endsWith('state=saas#/login') && href.includes('code=')) {
      const querystr = href.split('?')[1]
      const codestr = querystr.split('&')[0]
      const code = codestr.split('=')[1]
      if (code) {
        this.showcompany = true
        let loginData = await user.codeLogin(code)
        this.companyList = loginData.companyList as CompanyItemDto[]
        global.token = loginData.token
        sessionStorage.token = loginData.token
        // window.open('https://web.51zidan.com/', '_self')
        // this.handleRedirectTo()
      }
    }
    // end
    if (localStorage.userName) {
      this.userName = localStorage.userName
      this.password = localStorage.password
      this.isStorage = true
    }
    this.getCode()

    window.localStorage.removeItem('RSA_PUBLIC_KEY')
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    // 发送短信验证码
    async sendSmsCode() {
      // 验证手机号
      if (!this.userName) {
        this.$message.error('请输入手机号')
        return
      }
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(this.userName)) {
        this.$message.error('请输入正确的手机号')
        return
      }

      // 验证图形验证码
      if (!this.verityCode) {
        this.$message.error('请输入图形验证码')
        return
      }

      this.isSending = true

      try {
        const result = await user.sendLoginSmsCode({
          username: this.userName,
          code: this.verityCode,
          uuid: this.uuid
        })

        if (result.code === 200) {
          this.$message.success('验证码已发送')

          // 启动倒计时
          this.countdown = 60
          this.timer = setInterval(() => {
            this.countdown--
            if (this.countdown <= 0) {
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        } else if (result.code === 4002) {
          // 图形验证码错误，刷新图形验证码
          this.$message.error(result.msg || '图形验证码错误')
          this.getCode()
          this.verityCode = ''
          this.smsCode = ''
        } else {
          this.$message.error(result.msg || '发送失败')
        }
      } catch (error: any) {
        console.error('发送短信验证码失败:', error)
        this.$message.error(error.msg || '发送失败，请重试')
        this.getCode() // 刷新图形验证码
      } finally {
        this.isSending = false
      }
    },

    // 短信验证码登录
    async smsLogin() {
      // 验证手机号
      if (!this.userName) {
        this.$message.error('请输入手机号')
        return
      }
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(this.userName)) {
        this.$message.error('请输入正确的手机号')
        return
      }

      // 验证短信验证码
      if (!this.smsCode) {
        this.$message.error('请输入短信验证码')
        return
      }

      try {
        const data = await user.smsLogin({
          username: this.userName,
          verifyCode: this.smsCode
        })
        if (data.code === 200) {
          // 登录成功后跳转到选择企业页面
          await this.onNextStep()
        } else {
           this.$message.error(data.msg || '登录失败，请重试')
        }
      } catch (error: any) {
        console.error('短信验证码登录失败:', error)
        this.$message.error(error.msg || '登录失败，请重试')
        this.smsCode = ''
      }
    },
    async sureLogin(id: string | number, phone: string | number) {
      await user.switchLogin({
        username: this.isQr ? phone : this.userName,
        companyId: id
      })
      await this.handleRedirectTo()
    },
    async back() {
      this.showcompany = false
    },
    async getCode() {
      const photo = await user.getPhoto()
      this.verityImg = 'data:image/jpg;base64,' + photo.img
      this.uuid = photo.uuid
    },
    async onNextStep() {
      this.showcompany = true
      let commonlyList = await getCompanyListApi({ phone: this.userName })
      console.log(commonlyList, 'commonlyList')
      this.companyList = commonlyList as CompanyItemDto[]
    },
    async login() {
      await user
        .login({
          username: this.userName,
          password: this.password,
          uuid: this.uuid,
          code: this.verityCode
        })
        .catch(() => {
          this.getCode()
          this.verityCode = ''
          throw new Error()
        })

      if (this.password === '123456') {
        localStorage.isDefaultPassword = true
      } else {
        localStorage.removeItem('isDefaultPassword')
      }
      await this.onNextStep()
      if (this.isStorage) {
        if (localStorage.userName) {
          localStorage.userName = this.userName
          localStorage.password = this.password
        } else {
          localStorage.setItem('userName', this.userName)
          localStorage.setItem('password', this.password)
        }
      }
      // if (this.isStorage) {
      //     localStorage.userName = this.userName
      //     localStorage.password = this.password
      // } else if (localStorage.userName) {
      //     localStorage.removeItem('userName')
      //     localStorage.removeItem('password')
      // }
      // sessionStorage.setItem('tcflag', 'true')
      // sessionStorage.setItem('dayinsuretcflag', 'true')
      // this.handleRedirectTo()
    },
    qrLogin() {
      this.isQr = true
    },
    cancelQr() {
      this.isQr = false
    },
    handleRedirectTo() {
      if (user.isPcAdmin) {
        this.$router.push({
          path: '/'
        })
      } else {
        this.$router.push({
          path: '/pay'
        })
      }
    }
  }
})
